import { displayNotification } from "helpers";
import React, { useContext, useState } from "react";
import DataElement from "./DataElement";
import { FormDataContext } from "../contexts/FormContext";
import { useCreateOrUpdateSingleFormDataMutation } from "modules/pvs_activities/redux/service/formData";
import { processDataElementValue } from "modules/pvs_activities/helper.general";

const GroupColumn = (props) => {
    const formDataContext = useContext(FormDataContext);
    const [createOrUpdateSingleFormData] = useCreateOrUpdateSingleFormDataMutation();

    const handleChange = async (elId, val) => {
        try {
            if (formDataContext.mode === "preview") {
                formDataContext.setElementsData(existing => ({
                    ...existing,
                    [elId]: {
                        ...existing[elId],
                        content: val
                    }
                }));
            } else {
                console.log({val})
                const res = await createOrUpdateSingleFormData({
                    template_id: formDataContext.templateId,
                    section_id: formDataContext.sectionId,
                    element_id: elId,
                    movement_id: formDataContext.movementId,
                    ...(Array.isArray(val) ? {entries: val} : {
                        content: typeof val === 'object' ? val?.content : val,
                        list_id: typeof val === 'object' ? val?.list_id : null,
                        list_element_id: typeof val === 'object' ? val?.list_element_id : null,
                    })
                }).unwrap();
                if (res.success === false) {
                    displayNotification("error", "Error Saving Element Data [B]");
                }
            }
        } catch (e) {
            console.error({ e });
            displayNotification("error", "Error Saving Element Data [F]");
        }
    };

    return (
        <>
            {props.elements.map((el) => (
                <DataElement
                    key={el.id}
                    templateId={props.templateId}
                    elementsData={formDataContext.elementsData}
                    value={processDataElementValue(
                        el.data_element_type,
                        el.id,
                        el.list_appearance,
                        el.multiple_selection,
                        formDataContext.elementsData,
                        el?.properties?.default_value ?? ""
                    )}
                    onChange={handleChange}
                    isReadOnly={props.isReadOnly}
                    {...el}
                />
            ))}
        </>
    );
};

GroupColumn.defaultProps = {
    templateId: '',
    isReadOnly: false,
};

export default GroupColumn;
